<lib-plans-viewer
    *ngIf="accessToken"
    [facilityID]="facilityID"
    [accessToken]="accessToken"
    [graphicalViewID]="graphicalViewId"
    [hideControls]="true"
    [sharedView]="true"
    [isEmbedded]="true"
    [disableActions]="true"
></lib-plans-viewer>